import IBAN from 'iban'
import compileInvalidFormField from '../../shared/util/invalid_form_field'
import getMinAmount from '../../shared/util/get_min_amount'

export default function validateBillingItemField(field) {

  if (field.tagName === 'LABEL') return true
  if (field.dataset.skipValidation) return true

  let fieldValid = field.value.trim() !== ''
  const wasValid = !field.matches('.is-invalid')

  if (field.type === 'number') {
    fieldValid &&= parseFloat(field.value) >= getMinAmount(field)
  }
  if (field.name.includes('[iban]')) {
    fieldValid &&= IBAN.isValid(field.value)
  }

  if (!fieldValid) field.classList.add('is-invalid')
  if (wasValid && !fieldValid) compileInvalidFormField(field)

  return fieldValid
}
